import React from 'react';

import { Helmet, HelmetProvider } from 'react-helmet-async';



function Head(props) {

  return (
    <HelmetProvider>
      <Helmet>
        <title>{props.title}</title>
        <link rel="icon" type="image/x-icon" href='./assets/ico/favicon.ico' />
        <meta charset='UTF-8' />
        <meta http-equiv='X-UA-Compatible' content='IE=edge' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <meta name='author' content='Fabio Hernandez Mancipe' />
        <meta name='copyright' content='Fabio Hernandez Mancipe' />
        <meta name='title' content={props.title} />
        <meta name='description' content={props.description} />
      </Helmet>
    </HelmetProvider>
  )
}


export { Head };



